import { ProviderPhoneContact } from './provider.model';
import { SortModel } from './sort-model.model';

type ProviderCallOutcomeDetail = {
  description: string;
  callOutcomeID: number;
  callOutcomeName: string;
  callOutcomeBC: string;
  isActive: boolean;
};

enum ProviderCallOutcomeBC {
  Accepted = 'TPACCEPTED',
  Rejected = 'TPREJECTED',
  NoAnswer = 'TPNOANSWER',
}

interface ProviderCallOutcomeRequest {
  transportationProviderTier: string;
  tripLegReferenceID: string;
  search?: string;
  page: number;
  pageSize: number;
  sortModel: SortModel;
  hasCallOutcome?: boolean;
}

interface ProviderCallOutcomeResponse {
  transportationProviderID: number;
  transportationProviderName: string;
  transportationProviderTierID: number;
  transportationProviderState: 'active' | 'inactive';
  transportationProviderCoverageAreaIDs: number[];
  capacityOfTripsToServiceInDay: number;
  hasUnlimitedTrips: boolean;
  isClearToTransport: boolean;
  isInternal: boolean;
  transportationTypeBC: string;
  transportationProviderTierName: string;
  transportationProviderTierBC: string;
  transportationTypeName: string;
  transportationTypeID: number;
  transportationProviderPhones: ProviderPhoneContact[];
  numberOfCallOutcome: number;
  lastTripLegProviderCallOutcome: {
    tripLegProviderCallOutcomeID: number;
    callOutcomeID: number;
    callOutcomeRejectReasonID: number | null;
    callOutcome: string;
    createdOnUTC: string;
  };
}

export enum RideshareProvider {
  uber = 'UBER',
  lyft = 'LYFT',
}

interface RideshareOutboundPhoneNumber {
  provider: RideshareProvider;
  dispatchPhone?: string;
}

export {
  type ProviderCallOutcomeDetail,
  ProviderCallOutcomeBC,
  type ProviderCallOutcomeRequest,
  type ProviderCallOutcomeResponse,
  type RideshareOutboundPhoneNumber,
};
